import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';
import { filterContracts, calculateStats } from '../utils/helpers';

export const useRebelnet = (selectedPeriod, selectedCategoria, selectedMandante) => {
  const [contracts, setContracts] = useState([]);
  const [stats, setStats] = useState(null);
  const [mandanti, setMandanti] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const loadContracts = useCallback(async () => {
    try {
      const data = await api.getRebelnetContracts();
      
      if (mandanti.length === 0) {
        const allMandanti = [...new Set(data.items.map(c => c.list_name ? `${c.list_id} - ${c.list_name}` : c.list_id))].filter(Boolean);
        setMandanti(allMandanti);
      }
      
      if (categorie.length === 0) {
        const allCategorie = [...new Set(data.items.map(c => c.campaign_id))].filter(Boolean);
        setCategorie(allCategorie);
      }
      
      const filtered = filterContracts(data.items, {
        period: selectedPeriod,
        categoria: selectedCategoria,
        mandante: selectedMandante
      });
      
      setContracts(filtered.sort((a, b) => b.timestamp - a.timestamp));
      setStats(calculateStats(filtered));
    } catch (error) {
      console.error('Error loading contracts:', error);
    }
  }, [selectedPeriod, selectedCategoria, selectedMandante, mandanti.length, categorie.length]);

  const handleCategoriaChange = async (categoria) => {
    if (categoria !== 'all') {
      try {
        const data = await api.getRebelnetContracts();
        const mandantiInCategoria = [...new Set(
          data.items
            .filter(c => c.campaign_id === categoria)
            .map(c => c.list_name ? `${c.list_id} - ${c.list_name}` : c.list_id)
        )];
        setMandanti(mandantiInCategoria);
      } catch (error) {
        console.error('Error loading lists:', error);
      }
    } else {
      const data = await api.getRebelnetContracts();
      setMandanti([...new Set(data.items.map(c => c.list_name ? `${c.list_id} - ${c.list_name}` : c.list_id))].filter(Boolean));
    }
  };

  const refresh = () => {
    setLastUpdate(new Date());
    loadContracts();
  };

  useEffect(() => {
    loadContracts();
  }, [loadContracts]);

  return {
    contracts,
    stats,
    mandanti,
    categorie,
    lastUpdate,
    loadContracts,
    handleCategoriaChange,
    refresh
  };
};
